/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImpersonateUserRequest
 */
export interface ImpersonateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ImpersonateUserRequest
     */
    employeeId: string;
    /**
     * 
     * @type {string}
     * @memberof ImpersonateUserRequest
     */
    targetUserMpk: string;
    /**
     * 
     * @type {string}
     * @memberof ImpersonateUserRequest
     */
    employeeLogin: string;
}

/**
 * Check if a given object implements the ImpersonateUserRequest interface.
 */
export function instanceOfImpersonateUserRequest(value: object): value is ImpersonateUserRequest {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('targetUserMpk' in value) || value['targetUserMpk'] === undefined) return false;
    if (!('employeeLogin' in value) || value['employeeLogin'] === undefined) return false;
    return true;
}

export function ImpersonateUserRequestFromJSON(json: any): ImpersonateUserRequest {
    return ImpersonateUserRequestFromJSONTyped(json, false);
}

export function ImpersonateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImpersonateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'targetUserMpk': json['targetUserMpk'],
        'employeeLogin': json['employeeLogin'],
    };
}

export function ImpersonateUserRequestToJSON(json: any): ImpersonateUserRequest {
    return ImpersonateUserRequestToJSONTyped(json, false);
}

export function ImpersonateUserRequestToJSONTyped(value?: ImpersonateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'targetUserMpk': value['targetUserMpk'],
        'employeeLogin': value['employeeLogin'],
    };
}

